<!-- TEMPLATE -->
<template>
  <div class="dean-table-search">
    <div class="row dean-table-search-row">
      <div
        class="small-12 medium-6 large-9 hd-9 columns dean-table-search-term"
        v-if="showSearchTerm"
      >
        <transition name="slide-fade">
          <h3>
            Zoekresultaten voor: <em>"{{ searchTerm }}"</em>
          </h3>
        </transition>
      </div>
      <div
        class="small-12 medium-6 large-3 hd-3 columns dean-table-search-field"
      >
        <form id="search">
          <dean-search-field v-model="value" @input="activeSearch(value)">
            <slot></slot>
          </dean-search-field>
        </form>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanSearchField from './deanSearchField.vue';

// SVG
import search from '../svg/icons/search.svg';

@Component({
  components: {
    deanSearchField
  }
})
export default class deanTableSearch extends Vue {
  // PROPS
  @Prop() name!: string;

  value: string = '';
  searchTerm: string = '';
  showSearchTerm: boolean = false;

  // METHODS
  activeSearch(value: string) {
    if (value == '') {
      this.$set(this, 'showSearchTerm', false);
    } else {
      this.$set(this, 'showSearchTerm', true);
      this.$set(this, 'searchTerm', value);
      this.$emit('input', value);
    }
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN TABLE SEARCH
.dean-table-search {
  padding: 0;

  .dean-table-search-row {
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    padding: 0;
  }
}

// TRANSITION
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
